'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);

function throttle(callback, waitMs, immediate = true) {
  let timeout = null;
  let initialCall = true;
  return function throttled(...args) {
    const callNow = immediate && initialCall;
    const next = () => {
      callback.apply(this, args);
      timeout = null;
    };
    if (callNow) {
      initialCall = false;
      next();
    }
    if (!timeout) {
      timeout = window.setTimeout(next, waitMs);
    }
  };
}
function Throttle(delayMs, immediate = true) {
  return Component.createDecorator((options, key) => {
    if (!options.methods) {
      options.methods = {};
    }
    const functionToThrottle = options.methods[key];
    if (functionToThrottle && delayMs > 0) {
      options.methods[key] = throttle(functionToThrottle, delayMs, immediate);
    }
  });
}

exports.Throttle = Throttle;
exports.throttle = throttle;
